/**
 * @typedef {Object} Totals
 * @property {number} totalVat - section title
 * @property {number} totalNet - section title
 * @property {number} transactionCount - section title
 */

/**
 * @typedef {Object} RowData
 * @property {string} id - unique identifier
 * @property {number} errorCount - totals row errors
 * @property {number} warningCount - totals row warnings
 * @property {boolean} isProcessing - row is processing
 * @property {boolean} canTroubleshoot - row should be troubleshooted
 * @property {string} transactionType - transaction type
 * @property {string} transactionTypeName - client transaction type name
 * @property {Totals} totals - transaction totals
 */

/**
 * @typedef {Object} Section
 * @property {string} title - section title
 * @property {Array<RowData>} rows - list of rows
 */

/**
 * @typedef {Object} TableData
 * @property {Array<Section>} sections - unique identifier
 * @property {Totals} totals - totals row errors
 */

/**
 * Selects the current aggregates
 * @param {Object} [state={}] - store data
 * @returns {TableData|undefined}
 */
export const aggregatesSelector = ({ filing: { aggregates } = {} } = {}) => aggregates?.model;

/**
 * Selects aggregates meta
 * @param aggregates
 * @returns {*}
 */
export const aggregatesMetaSelector = ({ filing: { aggregates } = {} } = {}) => aggregates?.meta;
